import InsightsPanel from "./InsightsPanel";

const InsightsSideviewPanel = (props) => {
    return (<>
        <InsightsPanel {...props} flexGridColumnCount={[1,1,1,1]} small></InsightsPanel> 
            
    </>)
}

export default InsightsSideviewPanel